
var Modal = require('ffss/ui/Modal');

class Choice extends Modal {

    defaultOptions(){
        var options = {
            //modal options
            'modalClass': 'confirm-modal',
            'verticalCentered': true,
            'modalSize': 'xxl',
            'showFooter': false,
            'showHeader': false,

            //confirmModal options
            'contentClass': 'modal-confirm-content',
            'messageClass': 'modal-confirm-message',
            'messageContent': '',
            'btnCancelContent': 'Annuler',
            'btnCancelClass': 'btn btn-secondary btn-cancel',
            'showBtnCancel': false,
            'choices': null,
            /*[
                {
                    'id': 'Id of choice',
                    'btnClass': 'btn btn-primary btn-choice',
                    'btnContent': 'Label of choice',
                    '$content': $('<div/>')
                }
            ], 
            */

            //callbacks
            onChoice: function(event,choice,modal){return;},
            onCancel: function(event,modal){return;},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    constructor(options){
        super(options);
        //this.settings = $.extend(this.defaultOptions(),options);//done by super class

        // initialize attributes
        //this.$example = $('.class',this.$container);

        // bind events methods
        //this.onEvent = this.onEvent.bind(this);
        this.onChoice = this.onChoice.bind(this);
        this.onCancel = this.onCancel.bind(this);

        this.setBodyContent(this.buildContent());

        if(!this.settings.choices){
            window.notify("No choices defined in modal/Choice ",'danger');
        }
    }

    buildMessage(){
        let $message = $('<div/>')
        .addClass(this.settings.messageClass)
        .append(this.settings.messageContent);

        return $message;
    }

    buildContent(){
        var self = this;

        var $content = $('<div/>')
        .addClass(this.settings.contentClass);

        this.$message = this.buildMessage();


        let $rowChoices = $('<div/>')
        .addClass('row');

        for(var i in this.settings.choices){
            let choice = this.settings.choices[i];

            let id = choice.id;
            if(!id){
                id = i;
            }
            let btnClass = choice.btnClass;
            if(!btnClass){
                btnClass= 'btn btn-primary btn-choice';
            }
            let btnContent = choice.btnContent;
            if(!btnClass){
                btnContent= 'Choix ' + (i+1);
            }
            let $content = choice.$content;
            if(!$content){
                $content = $('<div/>').css('display','none');
            }

            let $btnChoice = $('<button/>')
            .attr('type','button')
            .attr('data-index',i)
            .attr('data-id',id)
            .addClass(btnClass)
            .append(btnContent)
            .on('click',function(event){
                let $btn = $(this);
                self.onChoice(event,$btn);
            })

            let $colChoice = $('<div/>')
            .addClass('col ml-1')
            .addClass('choice choice-'+i)
            .append(
                $('<div/>')
                .addClass('choice-content')
                .append(
                    $('<div/>')
                    .addClass('choice-action')
                    .addClass('d-flex justify-content-center')
                    .append($btnChoice)
                )
                .append($content)
            )

            $rowChoices.append($colChoice);
        }


        if(this.settings.showBtnCancel){
            this.$btnCancel = $('<button/>')
            .addClass(this.settings.btnCancelClass)
            .append(this.settings.btnCancelContent)
            .on('click',this.onCancel);

            let $colCancel = $('<div/>')
            .addClass('col ml-1')
            .addClass('choice choice-'+i)
            .append(
                $('<div/>')
                .addClass('choice-content')
                .append(
                    $('<div/>')
                    .addClass('choice-action')
                    .addClass('d-flex justify-content-center')
                    .append(this.$btnCancel)
                )
            )

            $rowChoices.append($colCancel);
        }

        $content
        .append(this.$message)
        .append($rowChoices)
        
        this.$modal.on('keydown',function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            switch(keycode){
                case 13:
                    self.$btnConfirm.trigger('click');
                break;
                default:
                //do nothing
                break;
            }
        });

        return $content;
    }
    

    onClose(event){
        this.onCancel(event);
        return super.onClose(event);
    }

    onChoice(event,$btn){
        this.dispose();
        let index = $btn.data('index');
        let choice = this.settings.choices[index];
        this.settings.onChoice(event,choice,this);
    }

    onCancel(event){
        this.dispose();
        this.settings.onCancel(event,this);
    }

}

module.exports = Choice;